import StayTypesComponent from "../../../../components/partner/Settings/experience-types/stay-types";

export default function StayTypes() {
  return <StayTypesComponent />;
}
